import { render, staticRenderFns } from "./health.vue?vue&type=template&id=6a27e718&scoped=true&"
import script from "./health.vue?vue&type=script&lang=js&"
export * from "./health.vue?vue&type=script&lang=js&"
import style0 from "./health.vue?vue&type=style&index=0&id=6a27e718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a27e718",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a27e718')) {
      api.createRecord('6a27e718', component.options)
    } else {
      api.reload('6a27e718', component.options)
    }
    module.hot.accept("./health.vue?vue&type=template&id=6a27e718&scoped=true&", function () {
      api.rerender('6a27e718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/components/health.vue"
export default component.exports